<template>
  <div class="date-picker-wrapper">
    <div class="picker-area">
      <el-time-picker
        v-model="localValue"
        is-range
        arrow-control
        @change="handleChange"
        clearable
        format="HH:mm:ss"
        value-format="HH:mm:ss"
        range-separator="至"
        style="width: 100%;"
        align="center"
      />
    </div>
    <div class="info-area">
      <div class="title">时分秒范围</div>
      <div class="current-value" v-if="localValue && localValue.length > 0">
        <span class="label">绑定值:</span>
        <span class="value">{{ localValue }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HmsRange',
  data() {
    return {
      localValue: ''
    }
  },
  created() {
    const now = new Date();
    this.localValue = [`${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`, `${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`]
  },
  methods: {
    handleChange() {
      console.log(this.localValue);
    }
  }
}
</script>

<style scoped>
.date-picker-wrapper {
  text-align: center;
}
.picker-area {
  margin-bottom: 20px;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.info-area {
  text-align: left;
  padding-top: 15px;
}
.title {
  font-size: 14px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 8px;
}
.current-value {
  font-size: 12px;
  color: #606266;
  background: var(--surface-2);
  padding: 8px;
  border-radius: 3px;
  word-break: break-all;
  line-height: 1.4;
}
.current-value .label {
  font-weight: bold;
  color: #409EFF;
  margin-right: 5px;
}
</style>
